function injectStyle (ssrContext) {
  require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-fac4ad54\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!../../../node_modules/string-replace-webpack-plugin/loader.js?id=mj8nq3d7c3!../../../node_modules/string-replace-webpack-plugin/loader.js?id=pgjqzajuokf!./SearchItemYoutube.vue")
}
var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!../../../node_modules/string-replace-webpack-plugin/loader.js?id=mj8nq3d7c3!../../../node_modules/string-replace-webpack-plugin/loader.js?id=pgjqzajuokf!./SearchItemYoutube.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-fac4ad54\",\"hasScoped\":true}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!../../../node_modules/string-replace-webpack-plugin/loader.js?id=mj8nq3d7c3!../../../node_modules/string-replace-webpack-plugin/loader.js?id=pgjqzajuokf!./SearchItemYoutube.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-fac4ad54",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/search/SearchItemYoutube.vue
// module id = 600
// module chunks = 0